export const IS_ONBOARDING_SHOWED = 'IS_ONBOARDING_SHOWED';
